module.exports = __webpack_public_path__ + "img/icon_graph.36ff5394.svg";